import authType from '@/config/authType';
// 配置文件
const formItems = [
  { type: 'input', label: '用户名称', model: 'userName', options: [], filterable: true, span: 6 },
  {
    type: 'selectNormal', label: '通讯录', options: [{ name: '91通讯录', value: '91通讯录' }], model: 'dictType', span: 6
  },
  { type: 'button', span: 12, buttonArr: [{ message: '查询', type: 'primary', fun: 'searchTableInfo' }, { message: '重置', type: 'warning', fun: 'resetTableInfo' }, { message: '导出', type: 'info', fun: 'exportExcel', permissions: authType.user.exportTableAuth }] }
];
const getColumnsMap = (methods) => {
  return {
    // userId: {
    //   title: '用户ID',
    //   key: 'userId',
    //   align: 'left',
    //   width: 300
    // },
    userName: {
      title: '用户名',
      key: 'userName',
      align: 'left',
      width: 100
    },
    realName: {
      title: '姓名',
      key: 'realName',
      align: 'left',
      width: 100
    },
    orgName: {
      title: '通讯录',
      key: 'orgName',
      align: 'left',
      width: 100
    },
    roleNames: {
      title: '角色',
      key: 'roleNames',
      align: 'left',
      minWidth: 200
    },
    action: {
      title: '操作',
      align: 'left',
      key: 'action',
      minWidth: 150,
      fixed: 'right',
      render: (h, { row }) => {
        const buttonArr = [];
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'info', size: 'small', permissionCode: authType.user.setRoleAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.setRole({ type: 'edit', id: row.userId, realName: row.realName });
              }
            }
          }, '角色分配')
        );
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small', permissionCode: authType.user.setPermissionAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.setPermission({ type: 'edit', id: row.userId, realName: row.realName });
              }
            }
          }, '分配权限')
        );
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small', permissionCode: authType.user.setAppAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.setAppAuth({ id: row.userId });
              }
            }
          }, '应用分配')
        );
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns };
